import { ActionTypes } from 'redux/utils/Details'

export default ActionTypes('USER_MANUAL')